import type { ILendingLimitSearch } from '@apply/api/src/api/LendingLimitApi';
import { calculateSummary } from '@apply/lending-limits';
import type { SummaryResult } from '@apply/lending-limits';
import { IBLLSummary } from '../components/lendingLimitAccordionPanel/components/common/constants/tables/interfaces/IBLLSummary';
import { mapResponseToSummaryInput } from './mapResponseToSummaryInput';
import { toBridgeRows } from './toBridgeRows';
import { toCoreRows } from './toCoreRows';
import { toGuarantorSummaryRows } from './toGuarantorSummaryRows';
import { toRentalRows } from './toRentalRows';
import { toSBARows } from './toSBARows';

/**
 * BE response → every grid's data source, in one call.
 *
 * Two steps, deliberately kept apart: `calculateSummary` (in `@apply/lending-limits`)
 * produces the numbers and is what the workbook verifies; the `to*Rows` transforms here
 * are presentation only — row order, row labels, and the subtotal/total rows the grids
 * display but the calculation has no notion of.
 */
export function buildLendingLimitTables(response: ILendingLimitSearch): IBLLSummary {
    return tablesFromSummary(calculateSummary(mapResponseToSummaryInput(response)));
}

/** The second half of {@link buildLendingLimitTables}, for callers holding a result already. */
export function tablesFromSummary(summary: SummaryResult): IBLLSummary {
    const { breakdown } = summary;

    return {
        guarantorSummaryData: toGuarantorSummaryRows(breakdown),
        coreData: toCoreRows(breakdown),
        bridgeData: toBridgeRows(breakdown),
        sbaData: toSBARows(breakdown),
        rentalData: toRentalRows(breakdown),
    };
}
